// Angular
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// App
import { AppComponent } from './app.component';

import { HttpClient } from '@angular/common/http';
import { MwCoreModule } from '@core/core.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MwAppConfig } from './@config';
import { AppStoreModule } from './store/store.module';
import { AppRoutingModule } from './app-routing.module';
import { MwUserApiService } from './services/user-api.service';
import { MwProjectsApiService } from './services/projects-api.service';
import { MwCountriesApiService } from './services/countries-api.service';
import { MwCustomersApiService } from './services/customers-api.service';
import { MwCustomerProjectsApiService } from './services/customer-projects-api.service';
import { MwOrdersApiService } from './services/orders-api.service';
import { MwDepartmentsApiService } from './services/departments-api.service';
import { MwAssignmentsApiService } from './services/assignments-api.service';
import { MwVehicleApiService } from './services/vehicle-api.service';
import { MwProductApiService } from './services/product-api.service';
import { MwNgrxUtilsService } from './services/utils/ngrx-utils.service';
import { MwDriversApiService } from './services/drivers-api.service';
import { MwContactsApiService } from './services/contact-api.service';
import { MwDeviationApiService } from './services/deviations-api.service';
import { MwUnitsApiService } from './services/units-api.service';

// Module for Material date picker handling native Date objects
import { MatNativeDateModule } from '@angular/material/core';

import { MwAppService } from './app.service';
import { MwDeliveryTimesApiService } from './services/delivery-times-api.service';
import { MwDeliveryTimeCategoriesApiService } from './services/delivery-time-categories-api.service';
import { NgxMatCustomDateAdapter } from './utils/date-adapter';
import { MwTerminalTransactionsApiService } from './services/terminal-transactions-api.service';
import { MwDateRangePickerModule } from './@shared/@components/date-range-picker';
import {
  NgxMatDateAdapter,
  NgxMatNativeDateModule,
} from '@angular-material-components/datetime-picker';
import { MwExportBatchesApiService } from './services/export-batches-api.service';
import { MwHttpModule } from '@core/http';
import { environment } from 'environments/environment';
import { CommonAppModule } from './@shared/common.module';
import { MwSharedModule } from '@core/shared.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    // Core
    MwCoreModule.auth(MwAppConfig),
    MwCoreModule.forRoot(MwAppConfig),
    MwHttpModule.forRoot({
      baseUrl: environment.baseUrl,
    }),
    MwSharedModule,
    CommonAppModule.forRoot(),
    // App routing module must be below core module, because wildcard route needs to be last
    AppRoutingModule,
    // Features
    AppStoreModule,
    // Material date picker
    MatNativeDateModule,
    NgxMatNativeDateModule,
    MwDateRangePickerModule.forRoot(),
  ],
  providers: [
    Title,
    MwUserApiService,
    MwProjectsApiService,
    MwCountriesApiService,
    MwCustomersApiService,
    MwCustomerProjectsApiService,
    MwOrdersApiService,
    MwDepartmentsApiService,
    MwAssignmentsApiService,
    MwVehicleApiService,
    MwProductApiService,
    MwDriversApiService,
    MwNgrxUtilsService,
    MwContactsApiService,
    MwDeviationApiService,
    MwUnitsApiService,
    MwAppService,
    MwDeliveryTimesApiService,
    MwDeliveryTimeCategoriesApiService,
    MwTerminalTransactionsApiService,
    {
      provide: NgxMatDateAdapter,
      useClass: NgxMatCustomDateAdapter,
    },
    MwExportBatchesApiService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
